export const brand = {
  primary: {
    main: "#FF5B19",
    light: "#FF8B5F",
    lighter: "#FFEFE8",
    dark: "#E64D0F",
    darker: "#CC440D",
    faded: "rgba(255, 91, 25, 0.08)",
  },
};

// Semantic Colors
export const semantic = {
  success: {
    main: "#22C55E",
    light: "#D1FADF",
    dark: "#15803D",
    background: "#ECFDF3",
    faded: "rgba(34, 197, 94, 0.08)",
  },
  warning: {
    main: "#F59E0B",
    light: "#FEF3C7",
    dark: "#B45309",
    background: "#FFFBEB",
    faded: "rgba(245, 158, 11, 0.08)",
  },
  error: {
    main: "#EF4444",
    light: "#FEE2E2",
    dark: "#B91C1C",
    background: "#FEF2F2",
    faded: "rgba(239, 68, 68, 0.08)",
  },
  info: {
    main: "#3B82F6",
    light: "#DBEAFE",
    dark: "#1D4ED8",
    background: "#EFF6FF",
    faded: "rgba(59, 130, 246, 0.08)",
  },
};

// Neutral Colors
export const neutral = {
  50: "#F9FAFB",
  100: "#F3F4F6",
  200: "#E5E7EB",
  300: "#D1D5DB",
  400: "#9CA3AF",
  500: "#6B7280",
  600: "#4B5563",
  700: "#374151",
  800: "#1F2937",
  900: "#111827",
};

// Text Colors
export const text = {
  primary: neutral[900],
  secondary: neutral[700],
  tertiary: neutral[500],
  disabled: neutral[400],
  inverse: "#FFFFFF",
  black: "#000000",
};

// Background Colors
export const background = {
  primary: "#FFFFFF",
  secondary: neutral[50],
  tertiary: neutral[100],
  disabled: neutral[200],
};

// Border Colors
export const border = {
  primary: neutral[200],
  secondary: neutral[300],
  third: neutral[400],
};

// Social Colors
export const social = {
  facebook: "#1877F2",
  google: "#DB4437",
  youtube: "#FF0000",
  tiktok: "#000000",
  instagram: "#E1306C",
  apple: "#000000",
};

// System Colors
export const system = {
  blue: "#0EA5E9",
  red: "#EF4444",
  green: "#22C55E",
  yellow: "#EAB308",
  orange: "#F97316",
  purple: "#A855F7",
};

export const theme = {
  light: {
    text: "#11181C",
    background: "#FFFFFF",
    icon: "#687076",
  },
  dark: {
    text: "#ECEDEE",
    background: "#151718",
    icon: "#9BA1A6",
  },
};

// Combined colors export
export const colors = {
  brand,
  semantic,
  neutral,
  text,
  background,
  border,
  social,
  system,
  theme,
};

export const gradients = {
  light: {
    fadeOverlay: ["rgba(255,255,255,0.2)", "rgba(255,255,255,1)"],
  },
  dark: {
    fadeOverlay: ["rgba(21,23,24,0.2)", "rgba(13, 15, 16, 1)"], // Using dark theme background color
  },
};
